import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { FluidsSubcutaneousAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface FluidsSubcutaneousActionFormGroup {
	amountGiven: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-fluids-subcutaneous-action-controls',
    templateUrl: './fluids-subcutaneous-action-controls.component.html',
    styleUrls: ['../../../common.scss', './fluids-subcutaneous-action-controls.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsSubcutaneousActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: FluidsSubcutaneousAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as FluidsSubcutaneousAction;
	}

	@Input() form!: FormGroup<FluidsSubcutaneousActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('amountGiven', this.formBuilder.control(this.action?.amountGiven ?? null));
	}
}